
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c62ea4fffec088546383395c5902a320.jpg"
          alt="아이폰 수리 작업장"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="inline-block border border-[#007AFF] rounded-full px-5 py-2.5 mb-6">
              <span className="text-lg font-medium text-[#007AFF] bg-white/90 px-4 py-1.5 rounded-full">청주아이폰,아이패드수리전문</span>
            </div>

            <h1 className="mb-6">
              <div className="text-4xl md:text-5xl font-light text-gray-200 mb-2">15년 경력의</div>
              <div className="text-4xl md:text-5xl font-medium text-white mb-2">신뢰할 수 있는</div>
              <div className="text-5xl md:text-6xl font-bold text-white flex items-center gap-3">
                <span className="text-4xl">📱</span> 아이폰 수리 전문가
              </div>
            </h1>

            <div className="text-lg text-gray-200 mb-6 leading-relaxed">
              <p className="mb-2">2010년부터 iPhone 3GS부터 최신 기종까지</p>
              <p>높은 부품 퀄리티와 세심한 수리 서비스</p>
            </div>

            <div className="mb-8">
              <p className="text-sm text-gray-300 mb-2">친절상담</p>
              <a
                href="tel:010-4687-3384"
                className="inline-flex items-center gap-3 text-2xl font-bold text-white hover:text-[#007AFF] transition-colors cursor-pointer"
              >
                <i className="ri-phone-fill text-[#007AFF]"></i>
                010-4687-3384
              </a>
            </div>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={scrollToContact}
                className="bg-[#007AFF] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#0051D5] transition-all duration-300 flex items-center gap-2 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
              >
                수리 상담하기
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <a
                href="https://maps.google.com/?q=청주시+상당구+성안로+19-5"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-transparent text-white border-2 border-white px-8 py-4 rounded-full text-base font-medium hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                위치 보기
              </a>
            </div>
            <div className="mt-3">
              <a
                href="https://blog.naver.com/roy1967"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#03C75A] text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-[#02b351] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-blogger-line"></i>
                블로그 방문
              </a>
            </div>
          </div>

          <div className="hidden md:block relative">
            <div className="relative">
              <div className="absolute top-0 right-0 w-72 h-72 rounded-3xl overflow-hidden shadow-2xl transform rotate-6 hover:rotate-3 transition-transform duration-300">
                <img
                  src="https://readdy.ai/api/search-image?query=Close-up%20professional%20iPhone%20screen%20repair%20process%2C%20technician%20hands%20working%20on%20iPhone%20display%20replacement%2C%20precision%20tools%2C%20clean%20white%20workspace%2C%20professional%20electronics%20repair%2C%20detailed%20macro%20shot%2C%20high%20quality%20repair%20service%2C%20modern%20technology%20maintenance&width=600&height=600&seq=hero-img-001&orientation=squarish"
                  alt="아이폰 수리 작업"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative mt-12 ml-12 w-64 h-80 rounded-3xl overflow-hidden shadow-2xl transform -rotate-3 hover:rotate-0 transition-transform duration-300">
                <img
                  src="https://readdy.ai/api/search-image?query=Multiple%20repaired%20iPhones%20and%20iPads%20displayed%20on%20white%20surface%2C%20various%20iPhone%20models%20arranged%20neatly%2C%20professional%20repair%20showcase%2C%20pristine%20condition%20devices%2C%20clean%20white%20background%2C%20high-end%20electronics%20display%2C%20quality%20repair%20results%20demonstration&width=500&height=700&seq=hero-img-002&orientation=portrait"
                  alt="수리 완료된 기기들"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
